import type { SeasonCampaignSummary } from '@multirx/shared/types/championship.js';

export type SeasonHistoryCardModel = {
  campaignKey: string;
  title: string;
  meta: string;
  statusLabel: string;
  statusClass: string;
};

export function filterPastCampaigns(campaigns: SeasonCampaignSummary[]): SeasonCampaignSummary[] {
  return campaigns.filter((c) => c.status !== 'active');
}

export function formatCampaignDateFr(iso: string): string {
  return new Intl.DateTimeFormat('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(iso));
}

export function toSeasonHistoryCardModel(campaign: SeasonCampaignSummary): SeasonHistoryCardModel {
  const divisions = campaign.divisions.map((d) => `D${d}`).join(' · ');
  const progress = `Meeting ${campaign.currentMeetingIndex} / ${campaign.meetingCount}`;
  return {
    campaignKey: campaign.campaignKey,
    title: formatCampaignDateFr(campaign.startedAt),
    meta: `${divisions} · ${progress}`,
    statusLabel: campaign.status === 'active' ? 'En cours' : 'Terminée',
    statusClass:
      campaign.status === 'active'
        ? 'seasons-campaign-badge--active'
        : 'seasons-campaign-badge--done',
  };
}
